(function ($) {
  $(document).ready(function ($) {
    // initial Klaviyo variable setup
    var _learnq = _learnq || [];

    // Define a variable to track if the form was successfully submitted
    var formSubmittedSuccessfully = false;

    // Creating & Setting Cookies for Modals
    function getCookie(cname) {
      var name = cname + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    }

    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    // END Creating & Setting Cookies for Modals

    // Logic for showing & hiding Klaviyo modal based on Cookies
    // Show modal after 5 seconds if not previously hidden
    if (getCookie('klaviyoModalHide') != 'true') {
      setTimeout(function () {
        $('body').addClass('noscroll');
        $('#klaviyo-modal')
          .addClass('show')
          .attr({ 'aria-hidden': 'false', 'aria-expanded': 'true' });
      }, 5000);
    } else {
      $('#klaviyo-modal').remove();
    }

    // END – Logic for showing & hiding Klaviyo modal based on Cookies

    var formSubmittedSuccessfully = false;
    var closeModalTimeout;

    // Function to hide the modal and set the cookie with dynamic expiration
    function hideModalAndSetCookie(expirationDays, immediate = false) {
      if (immediate) {
        clearTimeout(closeModalTimeout); // Clear any existing timeout to close the modal
        // Determine the expiration based on form submission status
        var expiration = formSubmittedSuccessfully
          ? 24 * 30 * 3
          : expirationDays; // 3 months if submitted, otherwise use provided duration
        setCookie('klaviyoModalHide', 'true', expiration);
        formSubmittedSuccessfully = false; // Reset submission flag
      } else {
        setCookie('klaviyoModalHide', 'true', expirationDays);
      }
      $('#klaviyo-modal')
        .removeClass('show')
        .attr({ 'aria-hidden': 'true', 'aria-expanded': 'false' });
      $('body').removeClass('noscroll');
    }

    // Adjust the immediate close functionality
    $(document).on('keydown', function (event) {
      if (event.key === 'Escape') {
        hideModalAndSetCookie(12, true); // Use immediate flag for dynamic expiration
      }
    });

    $('#klaviyo-dismiss').on('click', function () {
      hideModalAndSetCookie(12, true); // Use immediate flag for dynamic expiration
    });

    // Function to close modal with a delay, after successful form submission
    function closeModalWithDelay() {
      closeModalTimeout = setTimeout(function () {
        hideModalAndSetCookie(24 * 30 * 3); // 3 months
      }, 8000); // 8 seconds delay
    }

    /*****************************************************************
      Klaviyo form integration
    *****************************************************************/
    function KlaviyoSignup(listID, email, source) {
      var subscribed = false;
      $.ajax({
        type: 'POST',
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        data: {
          g: listID,
          //$fields: '$name, $gender, $age, $source, $consent, $email, Accepts Marketing',
          $fields: '$email, $source, $consent, Accepts Marketing',
          $email: email,
          $consent: ['email'],
          //pass in additional fields
          AcceptsMarketing: true,
          $source: source,
        },
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        error: function (err) {
          console.log('Could not connect to Klaviyo.');
          console.log(err);

          // trigger Klaviyo's identify call just to see if it starts tracking events sitewide
          _learnq.push(['identify', { $email: email }]);
          klaviyo.push(['identify', { $email: email }]);
        },
        success: function (res) {
          console.log('success');
          console.log(res);
          subscribed = true;

          // trigger Klaviyo's identify call just to see if it starts tracking events sitewide
          _learnq.push(['identify', { $email: email }]);
          klaviyo.push(['identify', { $email: email }]);

          // Set form submission success to true
          formSubmittedSuccessfully = true;

          if (res.data.is_subscribed == false) {
            console.log('success');
            $('#klaviyo-modal .successView')
              .removeClass('hide')
              .attr({ 'aria-hidden': 'false', 'aria-expanded': 'true' });
            $('#klaviyo-modal .signupView').addClass('hide');
            $('#klaviyo-modal .successView').removeClass('hide');

            closeModalWithDelay(24 * 30 * 3);
          }

          if (res.data.is_subscribed == true) {
            console.log('That email is already subscribed to our list');
            $('#klaviyo-modal .signupView').addClass('hide');
            $('#klaviyo-modal .alreadySubscribedView')
              .removeClass('hide')
              .attr({ 'aria-hidden': 'false', 'aria-expanded': 'true' });
            $('#klaviyo-modal .alreadySubscribedView').removeClass('hide');

            closeModalWithDelay(24 * 30 * 3);
          }
        },
        async: false,
      });
      return subscribed;
    }

    $('#signup-klaviyo').click(function (event) {
      event.preventDefault();
      const listID = $('#signup-klaviyo-form').data('listid');
      const source = 'Klaviyo Modal';
      const email = $('#signup-klaviyo-email').val();
      //const name = $('#signup-klaviyo-name').val();
      //const gender = $('#signup-klaviyo-gender').val();
      //const age = Number($('#signup-klaviyo-age').val());
      if (email != '') {
        //KlaviyoSignup(listID, name, email, gender, age, source);
        KlaviyoSignup(listID, email, source);
        $(this).siblings().children('input').removeClass('error');
      } else {
        $(this).siblings().children('input').addClass('error');
        console.log('requirements not met');
      }
    });
    /*****************************************************************
      END Klaviyo form integration
    *****************************************************************/
  });
})(jQuery);
